import {
  LOADING_USER,
  STORE_USER,
  STORE_USER_ERROR,
  USER_EXPIRED,
  USER_SIGNED_OUT,
} from "../Types/types";
import { setAuthHeader } from "../../Axios/axiosHeaders";
import { AUTH_CONSTANTS } from "../../Constants/constants";

const IsLDMAdmin = (roles: string[]): boolean => {
  if (roles === undefined || roles === null) {
    return false;
  }

  return roles?.indexOf(AUTH_CONSTANTS.LDM_ADMIN) !== -1;
};

const IsLDMService = (roles: string[]): boolean => {
  if (roles === undefined || roles === null) {
    return false;
  }

  return roles?.indexOf(AUTH_CONSTANTS.LDM_SERVICE) !== -1 || IsLDMAdmin(roles);
};

const IsLDMUser = (roles: string[]): boolean => {
  if (roles === undefined || roles === null) {
    return false;
  }

  return roles?.indexOf(AUTH_CONSTANTS.LDM_USER) !== -1 || IsLDMService(roles);
};


export function storeUser(user: any) {
  setAuthHeader(user.access_token);
  const roles: string[] = user?.profile[AUTH_CONSTANTS.LDM_ROLES_URL];

  return {
    type: STORE_USER,
    payload: {
      ...user,
      isLDMAdmin: IsLDMAdmin(roles),
      isLDMService: IsLDMService(roles),
      isLDMUser: IsLDMUser(roles),
    },
  };
}

export function loadingUser() {
  return {
    type: LOADING_USER,
  };
}

export function storeUserError() {
  return {
    type: STORE_USER_ERROR,
  };
}

export function userExpired() {
  return {
    type: USER_EXPIRED,
  };
}

export function userSignedOut() {
  return {
    type: USER_SIGNED_OUT,
  };
}
